import { useCallback, useEffect } from 'react'
import { batch, useSignal } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import {customerID} from '@signals'
import { monitoringResultsRefreshDataModalIsOpen, monitoringResultsScopeFilters } from "../@signals";


export default function useMonitoringResulRefreshDataModal() {
    const scopeData = useSignal({})
    const refreshData = useSignal(false)
    const refreshDataError = useSignal(null)
    const isLoading = useSignal(false)

    const handleSubmitScopeFilters = () => {
        isLoading.value = true
        const payload = {
            customerID: customerID.value,
            scheduleID: 0,
            retailer: monitoringResultsScopeFilters.value.retailer,
            sku: monitoringResultsScopeFilters.value.sku,
        }

        postSubmit(`${BACKEND_APIS.SCHEDULER}/v2/check/sku-mapping-monitoring`, payload).then(res => {
            scopeData.value = res
            isLoading.value = false
        }).catch(() => {
            isLoading.value = false
        })
    }

    const handleRefreshDataTest = () => {
        isLoading.value = true
        const payload = {
            customerID: customerID.value,
            scheduleID: 0,
            retailer: monitoringResultsScopeFilters.value.retailer,
            sku: monitoringResultsScopeFilters.value.sku,
        }

        postSubmit(`${BACKEND_APIS.SCHEDULER}/v2/run/sku-mapping-monitoring`, payload).then(res => {
            isLoading.value = false
            refreshData.value = true
        }).catch(() => {
            isLoading.value = false
            refreshDataError.value = 'An error occurred while attempting to refresh the data. Please try again later.'
        })
    }

    useEffect(() => {
        if (monitoringResultsRefreshDataModalIsOpen.value) batch(() => {
            handleSubmitScopeFilters()
        })
    }, [monitoringResultsRefreshDataModalIsOpen.value])

    const handleResetSignals = () => {
        refreshData.value = false
        refreshDataError.value = null
        scopeData.value = {}
    }

    return {
        isLoading: isLoading.value,
        scopeData: scopeData.value,
        refreshData: refreshData.value,
        refreshDataError: refreshDataError.value,
        handleRefreshDataTest,
        handleResetSignals
    }


}